import {
  ClinicPimsIntegrationFragment,
  ClinicPimsIntegrationType,
  VetDataIntegrationSystem,
} from 'shared/types/graphql';

type BitwerxCapability = 'ServiceReminders' | 'PaymentWritebacks';

// For Service Reminders, Bitwerx is required for Impromed (always) or multi-site Cornerstone
// For Payment Writebacks, Bitwerx is always required for AVImark, Cornerstone, and ImproMed
// NOTE: Impromed writebacks are disabled for the time being due to unreliability
const requiresBitwerxIntegration = (
  integrations: ClinicPimsIntegrationFragment[],
  capability: BitwerxCapability = 'ServiceReminders',
): boolean => {
  if (!integrations.length) return false;

  return integrations
    ?.filter((integration) => integration.isActive)
    ?.some((integration: ClinicPimsIntegrationFragment) => {
      const system = integration.vetdata?.system;
      const serviceReminderRequirements =
        system === VetDataIntegrationSystem.Impromed ||
        (system === VetDataIntegrationSystem.Cornerstone && integration.vetdata?.isMultiSite);
      const paymentWritebackRequirements =
        system === VetDataIntegrationSystem.Impromed ||
        system === VetDataIntegrationSystem.Cornerstone ||
        system === VetDataIntegrationSystem.Avimark;
      return capability === 'ServiceReminders' ? serviceReminderRequirements : paymentWritebackRequirements;
    });
};

export const getBitwerxIntegration = (
  integrations?: ClinicPimsIntegrationFragment[],
): ClinicPimsIntegrationFragment | undefined => {
  return integrations?.find((integration) => integration.type === ClinicPimsIntegrationType.Bitwerx);
};

export const needsBitwerxIntegration = (
  integrations: ClinicPimsIntegrationFragment[],
  capability: BitwerxCapability = 'ServiceReminders',
): boolean => {
  const bitwerxIntegration = getBitwerxIntegration(integrations);

  return requiresBitwerxIntegration(integrations, capability) && !bitwerxIntegration;
};

export const hasInitiatedBitwerxIntegration = (integrations?: ClinicPimsIntegrationFragment[]): boolean => {
  const bitwerxIntegration = getBitwerxIntegration(integrations);

  return !!(bitwerxIntegration && !bitwerxIntegration.isActive);
};
